<authority-labs-check-case
  (dataChange)="onChange()"
  [printPreview]="printPreview"
  [readonly]="readonly"
  [inspection]="inspection"
  [fieldSection]="fieldSection"
>
  <mat-form-field appearance="fill">
    <mat-select
      [(ngModel)]="inspection.value"
      *ngIf="!(readonly || printPreview)"
      (selectionChange)="onChange()"
    >
      <mat-option *ngFor="let option of options" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>

    <input
      *ngIf="readonly || printPreview"
      matInput
      [ngModel]="inspection.value"
      readonly
    />
  </mat-form-field>
</authority-labs-check-case>
